import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SportsRoutingModule } from './sports-routing.module';
import { SportDetailComponent } from './sport-detail/sport-detail.component';

import { MarketDetailComponent } from './inner-files/market-detail/market-detail.component';
import { BookmakerDetailComponent } from './inner-files/bookmaker-detail/bookmaker-detail.component';
import { FancyDetailComponent } from './inner-files/fancy-detail/fancy-detail.component';
import { RaceDetailComponent } from './inner-files/race-detail/race-detail.component';
import { MultiMarketComponent } from './multi-market/multi-market.component';
// import { BetSlipComponent } from './bet-slip/bet-slip.component';

import { SharedModule } from 'src/app/@shared/shared.module';


@NgModule({
  declarations: [
    SportDetailComponent,
    MarketDetailComponent,
    BookmakerDetailComponent,
    FancyDetailComponent,
    RaceDetailComponent,
    MultiMarketComponent,
    // BetSlipComponent,
  ],
  imports: [
    CommonModule,
    SportsRoutingModule,
    SharedModule
  ]
})
export class SportsModule { }
